import { createEditor } from './Factory'

module.exports = {
  createEditor
}
